export default __webpack_public_path__ + "static/media/29.2fd41945.jpg";